import React from 'react';
import { Wrapper, Category } from './styled';

const Categories = ({ data }) => {
  return (
    <>
      { data?.length > 0
        ? <Wrapper>
            { data?.map(tag => <Category key={ tag } >{ tag }</Category>) }
          </Wrapper>
        : null
      }
    </>

  );
};

export default Categories;
